import React, { ReactNode, useEffect, useState } from "react";
import { YearIndicator } from "./YearIndicator/YearIndicator";
import { ClimateIndicator } from "./ClimateIndicator/ClimateIndicator";
import { InfoModal } from "./InfoModal/InfoModal";
import { ClimateInfo } from "./ClimateInfo/ClimateInfo";

interface IProps {
    year: number;
    emission: boolean;
    changeSliderValue: (action: 'increase' | 'decrease') => void;
    children: ReactNode;
    visible: boolean;
    setSliderValue: (value: number) => void;
    sliderValue: number;
}

export function YearInfo({year, emission, changeSliderValue, children, visible, sliderValue, setSliderValue}: IProps) {
    const [showClimateInfo, setShowClimateInfo] = useState(false);

    useEffect(() => {
        if (!visible) {
            setShowClimateInfo(false);
        }
    }, [visible]);

    return (
        <>
            <YearIndicator
                visible={visible}
                changeSliderValue={changeSliderValue}
                year={year}
                showClimateInfo={showClimateInfo}
                setSliderValue={setSliderValue}
                sliderValue={sliderValue}
                climateInfo={<ClimateInfo year={year} showClimateInfo={showClimateInfo && visible} setShowClimateInfo={setShowClimateInfo} />}
            >{children}</YearIndicator>
            <ClimateIndicator
                visible={visible}
                year={year}
                emission={emission}
                setShowClimateInfo={setShowClimateInfo}
                showClimateInfo={showClimateInfo}
            />
            <InfoModal visible={visible} year={year} emission={emission} />

        </>
    )
}
